import { FC } from "react";
import { Code, Eye, SplitSquareHorizontal } from "lucide-react";
import { Button } from "../ui/button";
import { EditorViewMode } from "../../stores/UIStore";
import { cn } from "../../lib/utils";

interface ViewModeToggleProps {
    viewMode: EditorViewMode;
    onViewModeChange: (mode: EditorViewMode) => void;
}

const ViewModeToggle: FC<ViewModeToggleProps> = ({
    viewMode,
    onViewModeChange,
}) => {
    return (
        <div className="flex items-center gap-1 bg-gray-100/50 rounded-md">
           <Button
                variant="ghost"
                size="sm"
                className={cn(
                    "h-6 px-2 text-xs",
                    viewMode === EditorViewMode.PREVIEW && "bg-white shadow-sm"
                )}
                onClick={() => onViewModeChange(EditorViewMode.PREVIEW)}
                title="Show preview only"
            >
                <Eye className="h-3.5 w-3.5 mr-1" />
            </Button>
            <Button
                variant="ghost"
                size="sm"
                className={cn(
                    "h-6 px-2 text-xs",
                    viewMode === EditorViewMode.SPLIT && "bg-white shadow-sm"
                )}
                onClick={() => onViewModeChange(EditorViewMode.SPLIT)}
                title="Show both code editor and preview"
            >
                <SplitSquareHorizontal className="h-3.5 w-3.5 mr-1" />
            </Button>
            <Button
                variant="ghost"
                size="sm"
                className={cn(
                    "h-6 px-2 text-xs",
                    viewMode === EditorViewMode.CODE && "bg-white shadow-sm"
                )}
                onClick={() => onViewModeChange(EditorViewMode.CODE)}
                title="Show code editor only"
            >
                <Code className="h-3.5 w-3.5 mr-1" />
            </Button>
        </div>
    );
};

export default ViewModeToggle; 